import { createAction } from 'redux-actions'
import * as constants from './constants'

export const fetchSegmentList = createAction(constants.FETCH_SEGMENT_LIST)
export const fetchSegmentListPending = createAction(constants.FETCH_SEGMENT_LIST_PENDING)
export const fetchSegmentListFailed = createAction(constants.FETCH_SEGMENT_LIST_FAILED)
export const receiveSegmentList = createAction(constants.RECEIVE_SEGMENT_LIST)

export const fetchSegmentSetCardinality = createAction(constants.FETCH_SEGMENT_SET_CARDINALITY)
export const fetchSegmentSetCardinalityPending = createAction(constants.FETCH_SEGMENT_SET_CARDINALITY_PENDING)
export const fetchSegmentSetCardinalityFailed = createAction(constants.FETCH_SEGMENT_SET_CARDINALITY_FAILED)
export const receiveSegmentSetCardinality = createAction(constants.FETCH_SEGMENT_SET_CARDINALITY_SUCCESS)

export const fetchEndUserMembership = createAction(constants.FETCH_END_USER_MEMBERSHIP)
export const fetchEndUserMembershipPending = createAction(constants.FETCH_END_USER_MEMBERSHIP_PENDING)
export const fetchEndUserMembershipFailed = createAction(constants.FETCH_END_USER_MEMBERSHIP_FAILED)
export const receiveEndUserMembership = createAction(constants.FETCH_END_USER_MEMBERSHIP_SUCCESS)



// WEBPACK FOOTER //
// ./src/scripts/app/modules/segment/actions.js